import { defineCollection } from "@rebasepro/cms-types";
import { playerOf } from "../people";

// People in the friends feature (songbuzz_friend_person): one per Google or Apple account that has played with friends.
// The table is backend/src/friends.ts's, which creates it; this collection names its columns as they are. `who` is the
// account ("u:<uid>"), `id` the short public id a friend link carries. Admins can fix a name the filter missed.
const friendProfilesCollection = defineCollection({
    name: "Friend profiles",
    singularName: "Friend profile",
    slug: "friend_profiles",
    table: "songbuzz_friend_person",
    description: "The name and public friend id of each Google or Apple account that used Friends.",
    securityRules: [
        { operation: "select", roles: ["admin"] },
        { operation: "update", roles: ["admin"] },
    ],
    properties: {
        who: { name: "Account", type: "string", isId: "manual", admin: { readOnly: true, hideFromCollection: true } },
        player: playerOf("Player", "who", "player"),
        publicId: { name: "Friend id", description: "The short id a friend link or QR code carries", type: "string", columnName: "id", validation: { required: true, unique: true }, admin: { readOnly: true, hideFromCollection: true } },
        name: { name: "Name", type: "string" },
        look: { name: "Look", type: "map", keyValue: true, properties: {}, columnType: "jsonb", admin: { readOnly: true, span: 4, Preview: "../../admin/src/previews/Look" } },
        at: { name: "Last seen", type: "date", autoValue: "on_create", validation: { required: true }, admin: { readOnly: true } },
    },
    admin: {
        icon: "User",
        group: "System",
        openEntityMode: "side_panel",
        sort: ["at", "desc"],
        display: {
            title: ({ entity }) => entity.values.name || entity.values.publicId || undefined,
            date: "at",
        },
        listProperties: ["at"],
        form: {
            sections: [
                { key: "player", properties: ["name", "player", "look", "at"] },
                { key: "ids", title: "Behind the scenes", collapsed: true, properties: ["publicId", "who"] },
            ],
        },
    },
});

export default friendProfilesCollection;
